!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], a) : e.dayjs_locale_nl = a(e.dayjs);
}(this, function (e) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e;
  var a = {
    name: "nl",
    weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
    months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
    ordinal: function ordinal(e) {
      return e + ".";
    },
    weekStart: 1,
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD-MM-YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    relativeTime: {
      future: "over %s",
      past: "%s geleden",
      s: "een paar seconden",
      m: "een minuut",
      mm: "%d minuten",
      h: "een uur",
      hh: "%d uur",
      d: "een dag",
      dd: "%d dagen",
      M: "een maand",
      MM: "%d maanden",
      y: "een jaar",
      yy: "%d jaar"
    }
  };
  return e.locale(a, null, !0), a;
});